<h5 *ngIf="!loading && hasOrderOptions" class="text-center mb-3 mt-5">
  {{ 'OVERVIEW.VIEW' | translate }} {{ orderOptions.length }} {{ 'OVERVIEW.OPTION_ORDERS' | translate }}
</h5>

<app-orders-table [loading]="loading" [orders]="orderOptions" (onOrderClick)="onOrderClick($event)"></app-orders-table>
